import { getFileType } from 'helpers/getFileType';
import { FILETYPE_EXTENSIONS_PHOTO } from 'constants/files';

const fileIsPhoto = (file: File) => {
  const fileType = getFileType(file);
  return FILETYPE_EXTENSIONS_PHOTO.includes(fileType);
};

export { fileIsPhoto };
